module.exports = __webpack_public_path__ + "img/thanku.98f81b32.jpg";